module.exports = __webpack_public_path__ + "img/door-opened-icon-shadow.719f4e92.svg";